import { TableHeadCell } from "@digital-services/ui";

export const ApiSecretsHeaderRow = () => {
  return (
    <tr className="leading-[0px]">
      <TableHeadCell>Description</TableHeadCell>
      <TableHeadCell>Created on</TableHeadCell>
      <TableHeadCell>Expiration date</TableHeadCell>
      <TableHeadCell>Value</TableHeadCell>
      <TableHeadCell>Actions</TableHeadCell>
    </tr>
  );
};
